import { Grid, useMediaQuery } from '@material-ui/core'
import Close from '@material-ui/icons/Close'
import BlurDialog from 'components/utility/BlurDialog'
import { useDispatch, useSelector } from 'react-redux'
import { getAccountId } from 'redux/actions/accountActions'
import { setShowCollections } from 'redux/actions/harmonizeActions'
import { isVeryNarrow } from 'util/screenUtils'
import PlaylistCard from './PlaylistCard'

export default function Playlists({ setCollectionPlaylist, edit, close }) {
    const veryNarrow = isVeryNarrow(useMediaQuery)
    const { collections } = useSelector(state => state.harmonize)
    const { signedIn } = useSelector(state => state.account)
    const dispatch = useDispatch()
    const listCollections = () => {
        return (
            <Grid container spacing={veryNarrow ? 2 : 3}
                style={{
                    width: '100%', paddingTop: '1em', margin: 0,
                    overflowY: 'auto',
                    overscrollBehavior: 'contain',
                    height: '85vh'
                }}  >

                {collections.map(c =>
                    <Grid key={c.name} item xs style={{ display: 'flex', justifyContent: 'center' }}
                        onClick={async () => {
                            setCollectionPlaylist(c)
                            dispatch(setShowCollections(false))
                        }}><PlaylistCard collection={c} /></Grid>
                )}

            </Grid>
        )
    }
    const displayCollections = () => {
        const isMyCollections = signedIn && collections[0].user === getAccountId()
        return (<div>
            <BlurDialog content={listCollections}
                hideHelp title='Playlists'
                closeIcon
                editIcon={isMyCollections}
                edit={edit}
                top='1vh'
                close={close}
                blurStyle={{ zIndex: 10000 }}
                animationTime={200} />
        </div>)
    }
    return displayCollections()
}